import { useSnackbar } from 'notistack';
import { useQuery } from 'react-query';
import { CUSTOMERS_TABLE } from 'shared/constants/app';
import { useService } from 'shared/providers';
import { CustomerFilter, CustomerManagementGridItem } from 'shared/types/customerManagement';

export function useQueryCustomerWithFilters(userBrands: string[] | null, filters?: CustomerFilter) {
  const { customerService } = useService();
  const { enqueueSnackbar } = useSnackbar();
  const { data, isLoading, isFetching, refetch } = useQuery<CustomerManagementGridItem[], Error>(
    [CUSTOMERS_TABLE],
    () => customerService.getCustomersWithFilters(userBrands, filters),
    {
      onSuccess: data => {
        if (data.length === 0) enqueueSnackbar(`No matching customers were found. `, { variant: 'warning' });
      },
      retry: false,
    }
  );

  return { customers: data, isLoading, isFetching, refetch } as const;
}
